export { FeatureSwitch } from './lib/featureSwitch'
